import { render } from "./FormElementFileUpload.vue?vue&type=template&id=0b5ea974&ts=true"
import script from "./FormElementFileUpload.vue?vue&type=script&lang=ts"
export * from "./FormElementFileUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__